import { useCallback, useEffect, useMemo, useState } from 'react'
import { mediaStreamService } from '../services/media-stream.service'
import { useDevicesStore } from '../store/devices.store'

export function useDeviceEnumeration() {
  const [devices, setDevices] = useState<MediaDeviceInfo[]>([])
  const setDefaultsIfEmpty = useDevicesStore((s) => s.setDefaultsIfEmpty)

  const refresh = useCallback(async () => {
    const list = await mediaStreamService.enumerateDevices()
    setDevices(list)
    setDefaultsIfEmpty(list)
  }, [setDefaultsIfEmpty])

  useEffect(() => {
    refresh().catch(() => {})
    const onChange = () => {
      refresh().catch(() => {})
    }
    navigator.mediaDevices?.addEventListener?.('devicechange', onChange)
    return () => {
      navigator.mediaDevices?.removeEventListener?.('devicechange', onChange)
    }
  }, [refresh])

  const mics = useMemo(() => devices.filter((d) => d.kind === 'audioinput'), [devices])
  const cams = useMemo(() => devices.filter((d) => d.kind === 'videoinput'), [devices])
  const speakers = useMemo(() => devices.filter((d) => d.kind === 'audiooutput'), [devices])

  return { mics, cams, speakers, refresh }
}
